// extracted by mini-css-extract-plugin
module.exports = {"modalBox":"styles_modalBox__2G7ry","hidden":"styles_hidden__2q3DP","modalBody":"styles_modalBody__14jgE"};